import { jsxs as l, jsx as C } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ l(
  "svg",
  {
    "aria-label": "+amigo",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 51 18",
    fill: "none",
    children: [
      /* @__PURE__ */ C("rect", { width: "50.4", height: "18", rx: "4", fill: "#F4AF25" }),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M17.4189 12.4075C17.1126 12.57 16.785 12.6242 16.5421 12.6242C15.9821 12.6242 15.5595 12.3425 15.3696 11.8225C14.947 12.2992 14.3658 12.6242 13.6156 12.6242C12.0838 12.6242 10.9746 11.3784 10.9746 9.77518C10.9746 8.17196 12.0733 6.92621 13.6156 6.92621C14.2917 6.92621 14.8729 7.18619 15.3273 7.587V7.43534C15.3273 7.14286 15.4963 6.96954 15.7922 6.96954H16.2674C16.5633 6.96954 16.7323 7.14286 16.7323 7.43534V10.9451C16.7323 11.0643 16.7427 11.1509 16.8486 11.1509C16.9331 11.1509 17.007 11.1076 17.1126 11.0968C17.2712 11.0751 17.3662 11.1726 17.4296 11.3892L17.5879 11.9092C17.6831 12.2233 17.5879 12.3208 17.4189 12.4075ZM15.1053 9.77518C15.1053 8.94107 14.5666 8.43194 13.8905 8.43194C13.1507 8.43194 12.6543 9.0169 12.6543 9.77518C12.6543 10.5335 13.1507 11.1184 13.8905 11.1184C14.556 11.1184 15.1053 10.5985 15.1053 9.77518Z",
          fill: "#2C3490"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M27.7229 12.3967C27.406 12.5808 27.0997 12.6242 26.8248 12.6242C25.8212 12.6242 25.293 12.0825 25.293 11.0101V9.40687C25.293 8.80025 24.9761 8.42111 24.4267 8.42111C23.888 8.42111 23.5181 8.80025 23.5181 9.40687V12.0067C23.5181 12.31 23.3491 12.4833 23.0637 12.4833H22.2608C21.965 12.4833 21.8066 12.31 21.8066 12.0067V9.40687C21.8066 8.80025 21.4792 8.42111 20.9299 8.42111C20.3909 8.42111 20.021 8.80025 20.021 9.40687V12.0067C20.021 12.31 19.8627 12.4833 19.5669 12.4833H18.764C18.4788 12.4833 18.3098 12.31 18.3098 12.0067V8.62693C18.3098 8.5186 18.2675 8.46444 18.1935 8.46444C18.0878 8.46444 17.961 8.5511 17.8554 8.56193C17.7604 8.58359 17.6336 8.52943 17.57 8.26945L17.4328 7.63033C17.3694 7.35951 17.4117 7.22952 17.6336 7.11036C17.8554 6.98037 18.1723 6.92621 18.4152 6.92621C18.9859 6.92621 19.5139 7.17536 19.6937 7.82531C20.0424 7.30535 20.6022 6.92621 21.384 6.92621C22.1024 6.92621 22.6729 7.20786 23.0428 7.69532C23.4547 7.24035 24.0463 6.92621 24.807 6.92621C26.117 6.92621 27.0045 7.85781 27.0045 9.27688V10.8801C27.0045 10.9993 27.0256 11.0859 27.142 11.0859C27.1842 11.0859 27.2792 11.0643 27.3532 11.0426C27.5327 10.9884 27.6384 11.0643 27.7229 11.3242L27.8919 11.9092C27.9871 12.2017 27.9026 12.2992 27.7229 12.3967Z",
          fill: "#2C3490"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M28.3499 5.13883C28.3499 4.54304 28.8147 4.06641 29.3852 4.06641C29.9661 4.06641 30.431 4.54304 30.431 5.13883C30.431 5.73463 29.9661 6.21126 29.3852 6.21126C28.8147 6.21126 28.3499 5.73463 28.3499 5.13883ZM28.5293 11.0101V7.48951C28.5293 7.18619 28.6984 7.01287 28.9837 7.01287H29.7867C30.0825 7.01287 30.2411 7.18619 30.2411 7.48951V10.8801C30.2411 10.9993 30.262 11.0859 30.3783 11.0859C30.4206 11.0859 30.5155 11.0643 30.5896 11.0426C30.7586 10.9884 30.875 11.0643 30.9595 11.3242L31.1285 11.9092C31.213 12.2017 31.139 12.2992 30.9595 12.3967C30.6318 12.5808 30.336 12.6242 30.0613 12.6242C29.0578 12.6242 28.5293 12.0825 28.5293 11.0101Z",
          fill: "#2C3490"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M37.7172 7.63033L37.58 8.26945C37.5164 8.52943 37.4003 8.58359 37.2946 8.56193C37.189 8.5511 37.0622 8.46444 36.967 8.46444C36.8931 8.46444 36.8509 8.5186 36.8509 8.62693V11.855C36.8509 13.6966 35.5515 14.574 33.9139 14.574C32.8047 14.574 32.0018 14.1515 31.4733 13.6207C31.2938 13.4583 31.2411 13.2308 31.4628 12.9925L31.7691 12.6025C31.9277 12.4292 32.1285 12.375 32.3714 12.5917C32.6988 12.9058 33.2377 13.2308 33.9243 13.2308C34.6323 13.2308 35.2766 12.8841 35.2766 12.1042V11.5626C34.8754 11.855 34.3787 12.0284 33.8189 12.0284C32.3925 12.0284 31.3149 10.9451 31.3149 9.4827C31.3149 8.00947 32.3925 6.92621 33.8189 6.92621C34.5055 6.92621 35.0971 7.18619 35.5302 7.59783C35.7628 7.1212 36.2486 6.92621 36.7452 6.92621C36.9884 6.92621 37.3051 6.98037 37.527 7.11036C37.7383 7.22952 37.7913 7.35951 37.7172 7.63033ZM35.3929 9.4827C35.3929 8.74608 34.8963 8.22612 34.1992 8.22612C33.4913 8.22612 33.0053 8.74608 33.0053 9.4827C33.0053 10.2085 33.4913 10.7284 34.1992 10.7284C34.907 10.7284 35.3929 10.2085 35.3929 9.4827Z",
          fill: "#2C3490"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M37.9355 9.77518C37.9355 8.13946 39.1715 6.92621 40.8723 6.92621C42.5734 6.92621 43.7989 8.13946 43.7989 9.77518C43.7989 11.4109 42.5734 12.6242 40.8723 12.6242C39.1715 12.6242 37.9355 11.4109 37.9355 9.77518ZM42.1085 9.77518C42.1085 8.99523 41.5907 8.43194 40.8723 8.43194C40.1539 8.43194 39.6259 8.99523 39.6259 9.77518C39.6259 10.5551 40.1435 11.1184 40.8723 11.1184C41.5907 11.1184 42.1085 10.5551 42.1085 9.77518Z",
          fill: "#2C3490"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          opacity: "0.7",
          d: "M4.40088 9.90883V9.54406C4.40088 9.22369 4.57331 9.05804 4.87512 9.05804H7.89254V11.9861C7.89254 12.2955 7.72012 12.4723 7.41829 12.4723H6.91213C6.61031 12.4723 6.43787 12.3064 6.43787 11.9861V10.3948H4.87512C4.57331 10.3948 4.40088 10.2292 4.40088 9.90883Z",
          fill: "#2C3490"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9.92965 9.5441V9.90886C9.92965 10.2292 9.75723 10.3949 9.45541 10.3949H6.43799V7.46686C6.43799 7.15739 6.61042 6.98059 6.91224 6.98059H7.4184C7.72022 6.98059 7.89266 7.14648 7.89266 7.46686V9.05807H9.45541C9.75723 9.05807 9.92965 9.22372 9.92965 9.5441Z",
          fill: "#2C3490"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M45.9811 4.56789C45.9811 5.8293 45 6.85186 43.7898 6.85186C42.5795 6.85186 41.5984 5.8293 41.5984 4.56789C41.5984 3.93719 42.0889 3.4259 42.6941 3.4259C43.2992 3.4259 43.7898 3.93719 43.7898 4.56789C43.7898 5.19857 44.2803 5.70988 44.8855 5.70988C45.4906 5.70988 45.9811 5.19857 45.9811 4.56789Z",
          fill: "#2C3490"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M45.9993 4.56786C45.9993 5.19845 45.5006 5.70976 44.8856 5.70976C44.2704 5.70976 43.7717 5.19845 43.7717 4.56786C43.7717 3.93728 44.2704 3.42596 44.8856 3.42596C45.5006 3.42596 45.9993 3.93728 45.9993 4.56786Z",
          fill: "white",
          fillOpacity: "0.7"
        }
      )
    ]
  }
);
export {
  t as ClubBadge
};
